import React from "react";
import { TeamContainer, TeamMember, TeamMemberPosition, TeamMemberName } from "./teamElement"
const Team = () => {
    const teamMembers = [
        {
            name: "Dildiyal",
            position: "CEO",
        },
        {
            name: "Binoy",
            position: "Co-founder",
        },
        {
            name: "Riyas",
            position: "Co-founder",
        },

        // Add more team members here
    ];

    return (
        <div id="ourteam" style={{ backgroundColor: "#3b3434", height: "421px" }}>
            <h1 style={{ color: "white", paddingTop: "30px", textAlign: "center" }}>Our Team</h1>
            <TeamContainer>
                {teamMembers.map((member, index) => (
                    <TeamMember key={index}>
                        <TeamMemberName>{member.name}</TeamMemberName>
                        <TeamMemberPosition>{member.position}</TeamMemberPosition>
                    </TeamMember>
                ))}
            </TeamContainer>
        </div>
    );
};

export default Team;